import { ILocale } from "./types";

export const defaultLocale = {
  documentFieldLocaleId: "1",
  apiName: "en-US",
  title: "English (US)",
} as ILocale;
